import React from 'react';
import { Page } from '../Common/Components/Page';
import { OperationGroupsContent } from './Components/OperationGroupsContent';

export const OperationGroups = (): React.JSX.Element => (
  <Page title="Operation Groups" accessKey={'operationGroups'} isSearchable={true}>
    <OperationGroupsContent />
  </Page>
);
